import { ApplicationConfig, LOCALE_ID, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { MessageService } from 'primeng/api';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { DatePipe } from '@angular/common';
import { AmarilloPollo } from './core/theme/preset-amarillo-pollo';
import { CavazosTurquoise } from './core/theme/preset-cavazos-turquoise';
import { AppConfigService } from './core/services/app-config.service';
import { BrandingService } from './core/services/branding.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideAnimations(),
    provideHttpClient(withInterceptors([errorInterceptor, authInterceptor]), withFetch()),
    providePrimeNG({
      theme: {
        preset: CavazosTurquoise,
        options: {
          darkModeSelector: '.my-app-dark'
        }
      }
    }),
    provideAppInitializer(() => {
      // Secuencial: BrandingService lee appConfig.apiUrl, así que necesita
      // que AppConfigService haya terminado de cargar /config.json. Antes
      // corrían en paralelo (cada uno con provideAppInitializer separado)
      // y a veces ganaba el race el branding, pegándole a localhost:8000.
      // inject() debe resolverse antes del primer await — fuera del
      // contexto de inyección no funciona.
      const appConfig = inject(AppConfigService);
      const branding = inject(BrandingService);
      return (async () => {
        await appConfig.load();
        await branding.load();
      })();
    }),
    MessageService,
    DatePipe,
    { provide: LOCALE_ID, useValue: 'es-MX' }
  ]
};
